
import { Component, Watch } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ProjectMixin from '@/_mixins/project'

import draggable from 'vuedraggable'

import AddButton from '@/_components/button/add/add.vue'
import EditorViewer from '@/_components/editorJS/viewer/viewer.vue'
import DialogTemplate from '@/_components/dialog/template/template.vue'
import { initDialog } from '@/utils/dialog'
import DeleteHseContactDialog from '@/views/Project/Settings/views/Hse/dialogs/deleteContact.vue'
import { deserialise } from 'kitsu-core'
@Component({
    components: { draggable, EditorViewer, DialogTemplate, AddButton },
    mixins: [ProjectMixin],
})
export default class ContactsSettings extends Mixins<MixinInterface>(ProjectMixin) {
    get writable() {
        return this.currentProject
            ? this.currentProject.attributes.constraints.hseContacts.writable
            : false
    }

    @Watch('currentProjectId', { immediate: true })
    async watchActiveProject() {
        this.currentProjectId ? await this.getAllHSEContacts() : null
    }

    tableHeaders = [
        { text: this.getTranslation('fe_hse_module.label_contact_name') },
        { text: this.getTranslation('fe_hse_module.label_contact_description') },
        { text: this.getTranslation('fe_hse_module.label_contact_phone') },
        { text: '' },
    ]

    // CONTACT
    loadingContacts = false
    HSEContacts: Array<any> = []

    async getAllHSEContacts() {
        this.loadingContacts = true
        let url = this.$store.getters.project(this.currentProjectId).relationships.hseContacts.links
            .related
        let res = await this.getHSEContacts(url).catch((error: any) => {
            this.loadingContacts = false
        })

        this.HSEContacts = res
        this.loadingContacts = false
    }

    // ADD CONTACT
    postContact(data: any) {
        this.HSEContacts.push(data)
    }

    // UPDATE CONTACT
    updateLoading = false

    async updateOrder(value: any) {
        this.updateLoading = true
        let params = {
            updatedAt: this.$store.getters.hseContact(value.moved.element.id).attributes.updatedAt,
            data: {
                id: value.moved.element.id,
                type: value.moved.element.type,
                attributes: {
                    index: value.moved.newIndex,
                },
            },
        }

        let res = await this.patchHSEContact(params).catch((error: any) => {
            this.updateLoading = false
        })

        let hseContacts: any = { [res.id]: res }
        this.$store.commit('hseContacts', { ...this.$store.getters.hseContacts, ...hseContacts })

        this.HSEContacts[value.moved.oldIndex] = res

        this.updateLoading = false
    }
    navigateToContact(id: string) {
        this.$router.push({
            name: 'hse-edit-contact',
            params: { projectId: this.$route.params.projectId, hseContactId: id },
        })
    }

    // DELETE CONTACT

    async initDelete(contact: any, index: number) {
        let res = await initDialog(DeleteHseContactDialog, {
            hseContact: deserialise({ data: this.lodash.cloneDeep(contact) }).data,
        })
        if (res) {
            this.HSEContacts.splice(index, 1)
        }
    }
}
